export enum SmsJourneyStep {
  SaveAsDraft = 'saveAsDraft',
  SmsSent = 'smsSent',
  DrLetter = 'doctorLetter',
  TreatmentSelection = 'treatmentOptions',
  PracticeDocument = 'documentation',
  TreatmentDetails = 'treatmentOptionsPaymentFlow',
  PlanDetails = 'planDetails',
  Compliance = 'compliance',
  IdVerification = 'idVerification',
  PaymentForDeposit = 'deposit',
  BasiqVerification = 'basiq',
  PaymentMethod = 'paymentMethod',
  PaymentSummary = 'paymentSummary'
}
